import { Response } from '../../../../generic/v2/response/response';
import { UserRequestName } from '../../../user-request-name';

export abstract class UserResponse<T> extends Response<UserRequestName, T> {}
